import React, { FC, ReactElement,useContext } from "react";
import { useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import UserProfile from "../components/user/userProfile"

import Button from '@material-ui/core/Button';
// components
import PageTitle from "../components/ui/pageTitle";

// constants
import { APP_TITLE, PAGE_TITLE_SETTINGS } from "../helpers/constants";

// define css-in-js
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  })
);

const Settings: FC<{}> = (): ReactElement => {
  const classes = useStyles();



  return (
    <>
      <Helmet>
        <title>
          {PAGE_TITLE_SETTINGS} | {APP_TITLE}
        </title>
      </Helmet>
      <div className={classes.root}>
        <PageTitle title={PAGE_TITLE_SETTINGS} />
      </div>
      <UserProfile />
    </>
  );
};

export default Settings;
